import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Question20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_911)'>
      <path
        d='M10.0534 6.74145C9.28155 6.71174 8.60651 7.35689 8.61 8.13664L7.11001 8.14336C7.10282 6.53734 8.49109 5.18021 10.1111 5.24256C11.716 5.30431 13.0122 6.74956 12.8804 8.36541C12.838 8.88502 12.6559 9.38349 12.3532 9.808C12.0578 10.2224 11.6584 10.5512 11.1954 10.7616C10.7199 11.0346 10.75 11.5294 10.75 12H9.25001C9.25001 11.4211 9.26532 10.8712 9.56186 10.3506C9.78462 9.95944 10.1407 9.58663 10.5586 9.40323C11.0178 9.20169 11.3446 8.74328 11.3854 8.24344C11.4488 7.46627 10.8253 6.77115 10.0534 6.74145Z'
        fill='currentColor'
      />
      <path
        d='M10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44771 13 9 13.4477 9 14C9 14.5523 9.44771 15 10 15Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 0.25C4.61522 0.25 0.25 4.61522 0.25 10C0.25 15.3848 4.61522 19.75 10 19.75C15.3848 19.75 19.75 15.3848 19.75 10C19.75 4.61522 15.3848 0.25 10 0.25ZM1.75 10C1.75 5.44365 5.44365 1.75 10 1.75C14.5563 1.75 18.25 5.44365 18.25 10C18.25 14.5563 14.5563 18.25 10 18.25C5.44365 18.25 1.75 14.5563 1.75 10Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_911'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Question20.displayName = 'Question20';
export default Question20;
